@if (!embedService.embed) {
<app-header></app-header>
}
@if (loading$ | async) {
<div class="loader">
  <ct-lib-spinner></ct-lib-spinner>
</div>
} @else {
<div class="router-wrapper">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
}

@if (toastsService.toasts?.length > 0) {
<div class="toast-container">
  @for (toast of toastsService.toasts; track toast.id) {
  <ct-lib-toast [toast]="toast" (onDestroy)="toastsService.destroyToast($event)" @fadeInOutUp> </ct-lib-toast>
  }
</div>
}
<app-footer></app-footer>
